import React from "react";
import { Col } from "antd";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import {
  CheckboxFormField,
  InputFormField,
  SelectFormField
} from "@components/FormField/HookFormFields";
import { selectAvailableCountryOptions } from "@redux";
import { FullWidthInputWrapper, HalfWidthInputWrapper, StepperFormRow } from "@components";

export const ClientSecondAdress = ({ control, onCheck }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);

  return (
    <StepperFormRow>
      <Col xs={24} lg={8}>
        <p className="form-group-title">{trb(i18.Labels.ClientSecondAddress)}</p>
      </Col>

      <Col xs={24} lg={16} className="clientSameAddress">
        <CheckboxFormField
          control={control}
          name="clientAddress.0.clientSameRealAddress"
          label={trb(i18.Labels.ClientSameRealAddress)}
          onChange={onCheck}
        />
      </Col>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientAddress.1.data.addressCountry"
          title={trb(i18.Labels.AddressCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientAddress.1.data.addressCity"
          title={trb(i18.Labels.AddressCity)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientAddress.1.data.addressStreet"
          title={trb(i18.Labels.AddressStreet)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientAddress.1.data.addressPostCode"
          title={trb(i18.Labels.AddressPostCode)}
        />
      </HalfWidthInputWrapper>

      {/* new row */}
      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientPhone.0.data.clientPhoneNo"
          title={trb(i18.Labels.ClientPhoneNo)}
          type="tel"
          defaultValue="+"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientMail.0.data.clientEmail"
          title={trb(i18.Labels.ClientEmail)}
        />
      </HalfWidthInputWrapper>

      <FullWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientTaxPayerCountrys.0.data.clientTaxPayerCountry"
          title={trb(i18.Labels.ClientTaxPayerCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientTaxPayerCountrys.0.data.clientTaxPayerId"
          title={trb(i18.Labels.ClientTaxPayerId)}
        />
      </FullWidthInputWrapper>
    </StepperFormRow>
  );
};
